// extracted by mini-css-extract-plugin
export default {"cicrleDescription":"circle-description_cicrleDescription__-R9CU"};